<template>
  <div>
    <el-dialog
      title="拒絕原因"
      :visible.sync="showReason"
      width="80%"
      center
      top="20vh"
      :before-close="changeShow"
    >
      <div class="reason">{{ reason }}</div>
      <div class="commit-img">
        <div class="title">重新提交處方</div>
        <el-upload
          class="upload-demo"
          :headers="headers"
          :action="url"
          :before-upload="beforeAvatarUpload"
          :on-remove="handleRemove"
          :on-success="handleSuccess"
          :file-list="fileList"
          list-type="picture"
          multiple
        >
          <el-button size="small" type="primary">點擊上傳</el-button>
          <div slot="tip" class="el-upload__tip">
            上傳處方和病歷圖片（共2張）
          </div>
        </el-upload>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="changeShow">取 消</el-button>
        <el-button type="primary" @click="againCommit">確認修改</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { changePrescriptionImage } from "@api/user";
import { VUE_APP_API_URL } from "@utils";
import imageConversion from "image-conversion";
export default {
  name: "ChangePrescriptionImg",
  props: ["showReason", "order_id", "reason"],
  data() {
    return {
      headers: {
        "Authori-zation": "Bearer " + this.$store.state.app.token
      },
      url: `${VUE_APP_API_URL}/upload/image`,
      fileList: [] //默认值
    };
  },
  methods: {
    beforeAvatarUpload(file) {
      return new Promise((resolve, reject) => {
        let isLt2M = file.size / 1024 / 1024 < 1; // 判定图片大小是否小于4MB
        if (isLt2M) {
          resolve(file);
        }
        // 压缩到400KB,这里的400就是要压缩的大小,可自定义
        imageConversion
          .compressAccurately(file, 400)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    handleRemove(file, fileList) {
      this.fileList = fileList;
    },
    handleSuccess(res, file, fileList) {
      this.fileList = fileList;
    },
    againCommit() {
      let imageList = [];
      if (this.fileList.length < 2) {
        this.$message({
          showClose: true,
          message: "需上傳處方和病歷圖片（共2張）",
          type: "error"
        });
        return;
      }
      this.fileList.forEach(item => {
        imageList.push(item.response.data.url);
      });
      const data = {
        order_id: this.order_id,
        imageList: imageList
      };
      changePrescriptionImage(data).then(res => {
        if (res.status === 200) {
          this.$emit("changeShow", false);
          this.$parent.getDetail();
        }
      });
    },
    changeShow() {
      this.$emit("changeShow", false);
    }
  }
};
</script>

<style scoped>
.reason {
  color: #ff1919;
}
.commit-img {
  margin-top: 3vh;
  text-align: center;
}
.commit-img .title {
  width: 100%;
  background: #eee;
  line-height: 30px;
  margin-bottom: 10px;
}
</style>
